import * as Yup from "yup";
let deviceList = [];
let ownerList = [];
let categoryList = [];

export const taggingInitials = {
  vehicle_type: "old",
  device: "",
  vehicle_owner: "",
  state_code: "",
  district_code: "",
  district: "",
  vehicle_number: "",
  owner_id: "",
  engine_no: "",
  chassis_no: "",
  vehicle_make: "",
  vehicle_model: "",
  category: "",
  device_registration_date: "",
  device_sell_amount: "",
  payment_mode: "",
  rcFile: null,
};

export const taggingFields = {
  vehicle_type: {
    name: "vehicle_type",
    type: "select",
    label: "Vehicle Type",
    validation: Yup.string().oneOf(["old", "new"]).required("Vehicle Type is required"),
    options: [
      { label: "Old Vehicle", value: "old" },
      { label: "New Vehicle", value: "new" },
    ],
  },
  device: {
    name: "device",
    type: "select",
    label: "Device Imei",
    validation: Yup.string().required("tagDeviceForm.validation.deviceRequired"),
    options: deviceList,
  },
  vehicle_owner: {
    name: "vehicle_owner",
    type: "tel",
    label: "Owner Mobile",
    validation: Yup.string()
      .matches(/^\d{10}$/, 'tagDeviceForm.validation.mobileFormat')
      .required('tagDeviceForm.validation.mobileRequired'),
  },
  state_code: {
    name: "state_code",
    type: "select",
    label: "State",
    validation: Yup.string(),
    options: [],
  },
  district_code: {
    name: "district_code",
    type: "select",
    label: "District",
    validation: Yup.string().required("tagDeviceForm.validation.districtCodeRequired"),
    options: [],
    disabled: true,
  },
  // district: {
  //   name: "district",
  //   type: "select",
  //   label: "district",
  //   validation: Yup.string().required("tagDeviceForm.validation.districtRequired"),
  //   options: [],
  // },
  vehicle_number: {
    name: "vehicle_number",
    type: "text",
    label: "Vehicle Number",
    validation: Yup.string().when("vehicle_type", {
      is: "old",
      then: (schema) =>
        schema
          .transform((value) => value?.toUpperCase())
          .matches(
            /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{4}$/,
            "Enter a valid Indian Vehicle Registration Number (Example: BR01AB1234)"
          )
          .required("Vehicle Number is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  },
  owner_id: {
    name: "owner_id",
    type: "text",
    label: "Owner ID",
    disabled: true,
    validation: Yup.string().when("vehicle_type", {
      is: "new",
      then: (schema) => schema.required("Owner ID is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  },
  engine_no: {
    name: "engine_no",
    type: "text",
    label: "EngineNo",
    validation: Yup.string().required("tagDeviceForm.validation.engineNoRequired"),
  },
  chassis_no: {
    name: "chassis_no",
    type: "text",
    label: "Chassis No",
    validation: Yup.string().required("tagDeviceForm.validation.chassisNoRequired"),
  },
  vehicle_make: {
    name: "vehicle_make",
    type: "select",
    label: "Vehicle Make",
    validation: Yup.string().required("Vehicle Make is required"),
    options: [],
  },
  // vehicle_model: {
  //   name: "vehicle_model",
  //   type: "select",
  //   label: "Vehicle Model",
  //   validation: Yup.string().required("Vehicle Model is required"),
  //   options: [],
  //   disabled: true,
  // },
  vehicle_model: {
  name: "vehicle_model",
  type: "text",
  label: "Vehicle Model",
  validation: Yup.string().required("Vehicle Model is required"),
},
  category: {
    name: "category",
    type: "select",
    label: "Vehicle Category",
    validation: Yup.string().required("tagDeviceForm.validation.vehicleCategoryRequired"),
    options: categoryList,
  },
  device_registration_date: {
  name: "device_registration_date",
  type: "date",
  label: "Device Registration Date",

  // Prevent future dates in the date picker/input
  max: new Date().toISOString().split("T")[0],

  validation: Yup.string()
    .required("Device Registration Date is required")
    .test(
      "not-future-date",
      "Device Registration Date cannot be in the future",
      (value) => {
        if (!value) return true;

        const selectedDate = new Date(`${value}T00:00:00`);
        const today = new Date();

        today.setHours(0, 0, 0, 0);

        return selectedDate <= today;
      }
    ),
},
  device_sell_amount: {
    name: "device_sell_amount",
    type: "number",
    label: "Device Sale Amount Including GST",
    validation: Yup.number()
      .typeError("Amount must be number")
      .required("Sale Amount is required")
      .positive("Amount must be greater than 0"),
  },
  payment_mode: {
    name: "payment_mode",
    type: "select",
    label: "Payment Mode",
    validation: Yup.string(), // Optional
    options: [
      {
        label: "Cash",
        value: "cash",
      },
      {
        label: "Bank",
        value: "bank",
      },
    ],
  },
  rcFile: {
    name: "rcFile",
    type: "file",
    label: "Registration Certificate",
    validation: Yup.mixed().required("tagDeviceForm.validation.registrationCertificateRequired"),
  },
};
